var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { class: ["material-icons", "md-" + _vm.size] }, [
    _vm._v(" " + _vm._s(_vm.icon) + " "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }